/**
 * @file color scale and params
 */
import {scaleSequential, interpolatePlasma} from 'd3-scale';
import {interpolateRdPu} from 'd3-scale-chromatic';

const maxSpeed = 40;
const speedStep = 5;
const divergingScale = scaleSequential(interpolatePlasma).domain([0, maxSpeed]);
const sequentialScale = scaleSequential(interpolateRdPu).domain([0, maxSpeed]);

function colorScale(value, sequentialColorScale = false) {
    return sequentialColorScale ?
        sequentialScale(value) :
        divergingScale(value);
}
export {
    maxSpeed,
    speedStep,
    colorScale
}



// WEBPACK FOOTER //
// ./src/lib/scale.js